// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"393a176e","450":"c434ae3a","529":"4b3d4e5a"}[chunkId] + ".chunk.js";
};